import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import axios from "axios";
import { API } from "../lib/api";

const KONTAKT = {
    title: "Kontakt",
    body: (
        <>
            <p>Wir freuen uns auf Ihre Nachricht.</p>
            <p>
                <strong>Möbus Umweltschutz GmbH</strong>
                <br />
                Andreas-Schubert-Str. 01
                <br />
                01844 Neustadt
            </p>
            <p>
                Telefon:{" "}
                <a href="tel:+4935965592990" className="text-moebus-green hover:underline">
                    +49 (0) 3596 5592990
                </a>
                <br />
                E-Mail:{" "}
                <a href="mailto:info@moebus-umweltschutz.de" className="text-moebus-green hover:underline">
                    info@moebus-umweltschutz.de
                </a>
            </p>
        </>
    ),
};

export function renderLegalContent(content) {
    const blocks = (content || "").split(/\n{2,}/);
    const out = [];
    let list = [];
    const flush = () => {
        if (list.length) {
            out.push(
                <ul key={`ul-${out.length}`} className="list-disc pl-6 space-y-1.5">
                    {list.map((item, i) => (
                        <li key={i}>{item}</li>
                    ))}
                </ul>
            );
            list = [];
        }
    };
    blocks.forEach((block, i) => {
        const t = block.trim();
        if (!t) return;
        if (t.startsWith("## ")) {
            flush();
            out.push(
                <h2 key={i} className="font-heading font-bold text-xl md:text-2xl text-moebus-deep pt-4">
                    {t.slice(3)}
                </h2>
            );
        } else if (t.startsWith("- ")) {
            list.push(t.slice(2));
        } else {
            flush();
            out.push(<p key={i}>{t}</p>);
        }
    });
    flush();
    return out;
}

export default function StaticPage({ pageKey }) {
    const isLegal = pageKey === "impressum" || pageKey === "datenschutz";
    const [page, setPage] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (isLegal) {
            axios
                .get(`${API}/pages/${pageKey}`)
                .then(({ data }) => setPage(data))
                .catch(() => {});
        }
    }, [pageKey, isLegal]);

    const title = isLegal ? page?.title || (pageKey === "impressum" ? "Impressum" : "Datenschutzerklärung") : KONTAKT.title;

    return (
        <div className="min-h-screen bg-white">
            <div className="bg-moebus-deep text-white py-16 md:py-20">
                <div className="container mx-auto px-4 md:px-8">
                    <Link
                        to="/"
                        className="inline-flex items-center gap-2 text-sm text-emerald-400 hover:text-emerald-300 mb-4"
                    >
                        <ArrowLeft size={16} /> Zurück
                    </Link>
                    <h1 className="font-heading font-bold text-4xl md:text-5xl">{title}</h1>
                </div>
            </div>
            <div className="container mx-auto px-4 md:px-8 py-12 md:py-16">
                <div
                    data-testid={`page-content-${pageKey}`}
                    className="max-w-3xl mx-auto space-y-5 text-base md:text-lg text-slate-700 leading-relaxed"
                >
                    {isLegal ? renderLegalContent(page?.content) : KONTAKT.body}
                </div>
            </div>
        </div>
    );
}
